<template>
  <div>
    <BulkOpsHeader
      @new="newDialog = true"
    >
      Contact Operations
    </BulkOpsHeader>
    <BulkOpsTable
      :rows.sync="contactOps"
      :headers="headers"
      :totalRows="pagination.totalRows"
      :pagination="pagination"
      @fetch="pagination=arguments[0]"
    >
      <template v-slot:default="prop">
        <td>
          {{prop.row.count}}
        </td>
        <td>
          <div
            v-if="JSON.parse(prop.row.update_json).add_tags"
          >
            <b>Add Tags: </b>
            <v-chip
              v-for="tag in JSON.parse(prop.row.update_json).add_tags"
              :key="tag"
              small
            >
              {{tag}}
            </v-chip>
          </div>
          <div
            v-if="JSON.parse(prop.row.update_json).remove_tags"
          >
            <b>Remove Tags: </b>
            <v-chip
              v-for="tag in JSON.parse(prop.row.update_json).remove_tags"
              :key="tag"
              small
              outline
            >
              {{tag}}
            </v-chip>
          </div>
          <div
            v-if="JSON.parse(prop.row.update_json).remove_all_tags"
          >
            <b>Remove All Tags</b>
          </div>
          <div
            v-if="JSON.parse(prop.row.update_json).send_sms_solicitation"
          >
            <b>Send SMS Consent Solicitation</b>
          </div>
          <div
            v-if="typeof JSON.parse(prop.row.update_json).set_active !== 'undefined'"
          >
            <b>{{JSON.parse(prop.row.update_json).set_active ? 'Enable Users' : 'Disable Users'}}</b>
          </div>
        </td>
        <td style="text-transform: capitalize;">
          {{prop.row.status}}
        </td>
      </template>
    </BulkOpsTable>
    <BulkOpsDialog
      v-if="newDialog"
      title="New Bulk Contact Operation"
      :update_actions="bulkOpActions"
      @save="save(arguments[0])"
      @cancel="newDialog = false"
    />
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import GlobalConstants from '@/globals'
import pagination from '@/components/global/pagination'
import BulkOpsHeader from '@/components/admin/bulkops/BulkOpsHeader'
import BulkOpsTable from '@/components/admin/bulkops/BulkOpsTable'
import BulkOpsDialog from '@/components/admin/bulkops/BulkOpsDialog'

export default {
  name: 'ContactBulkOps',
  components: {
    BulkOpsHeader,
    BulkOpsTable,
    BulkOpsDialog
  },
  mixins: [
    pagination
  ],
  data () {
    return {
      contactOps: [],
      loading: false,
      pagination: {},
      totalRows: null,
      pages: null,
      newDialog: false,
      interval: null,
      headers: [
        { text: 'Count', width: 20, sortable: false },
        { text: 'Action', width: 180, sortable: false },
        { text: 'Status', width: 60, sortable: false },
        { text: 'Run Time', width: 60, sortable: false },
        { text: 'Progress', width: 60, sortable: false },
      ],
      bulkOpActions: [
        {
          "title": "Add Tags",
          "prop": "add_tags",
          "type": "tags",
          "type_scope": "contact",
          "value": null,
          "hint": "Add this existing or new tag to all contacts entered"
        },
        {
          "title": "Remove Tags",
          "prop": "remove_tags",
          "type": "tags",
          "type_scope": "contact",
          "value": null,
          "hint": "Remove this existing tag from all contacts entered"
        },
        {
          "title": "Remove All Tags",
          "prop": "remove_all_tags",
          "type": "checkbox",
          "value": null,
          "hint": "Remove all tags from a contact"
        },
        {
          "title": "Send SMS Consent Solicitation",
          "prop": "send_sms_solicitation",
          "type": "checkbox",
          "value": null,
          "hint": "Attempt to send a SMS consent solicitation to all contacts entered, if they have a phone number and have not already consented or received a consent request within the last 90 days"
        },
        {
          "title": "Set Enabled / Disabled",
          "prop": "set_active",
          "type": "dropdown",
          "options": [
            {
              "name": "Enabled",
              "value": true
            },
            {
              "name": "Disabled",
              "value": false
            }
          ],
          "value": null,
          "hint": "Allow contact to log in and receive e-mails"
        }
      ]
    }
  },
  created () {
    this.documentTitle('Contact Operations')
  },
  methods: {
    restartInterval () {
      clearInterval(this.interval)
      var countWorking = 0
      this.contactOps.forEach((item) => {
        if (["finished", "failed"].indexOf(item.status) == -1)
          countWorking++
      })
      if (countWorking > 0) {
        this.interval = setInterval(() => {
          this.fetch()
        }, 5000)
      }
    },
    fetch () {
      this.loading = true
      api.bulkops.contact.list({
        pageNum: this.pagination.page, count: this.pagination.rowsPerPage, ordering: '-created_at'
      })
        .then(data => {
          this.contactOps = data.results
          this.pagination.totalRows = data.count
          this.pagination.page = data.page_number
          this.loading = false
          this.componentCreated = true
          this.restartInterval()
        })
    },
    save (newOp) {
      var contact_ids = []
      var update_json = {}
      newOp.update.split(/\r?\n/).forEach((id) => {
        if (id !== "") {
          contact_ids.push(parseInt(id))
        }
      })
      newOp.props.forEach((prop) => {
        if (prop.value !== null && prop.value !== "") {
          update_json[prop.prop] = prop.value
        }
      })
      api.bulkops.contact.save({contact_ids: JSON.stringify(contact_ids),
                                 update_json: JSON.stringify(update_json)})
      .then(() => {
        this.newDialog = false
        this.fetch()
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
  }
}
</script>
